import type { CompanyFeaturesSchemaFragment } from 'gql/__generated__/graphql'

/**
 * Re-export generated types from GraphQL schema.
 * These types are auto-generated and always in sync with backend.
 */
export type {
  CompanyFeatures,
  CompanyFeaturesInput,
  CompanyFeaturesSchemaFragment,
} from 'gql/__generated__/graphql'

/**
 * Default values for company features.
 * Used when features are null/undefined.
 */
export const DEFAULT_COMPANY_FEATURES = {
  ANALYTICS_ENABLED: false,
  DOC_TO_COURSE_ENABLED: false,
  DOC_TO_COURSE_MONTHLY_LIMIT: 20,
  DOC_TO_COURSE_WITHOUT_AI_ENABLED: false,
  DAM_ENABLED: false,
  DYNAMIC_SCORM_ENABLED: false,
  CONTENT_SPACE_ENABLED: false,
} satisfies CompanyFeaturesSchemaFragment
